/* eslint-disable */
export default {
  removeParticipant: 'Poista osallistuja',
  confirmStr1: 'Haluatko varmasti poistaa osallistujan',
  confirmStr2: 'tästä puhelusta?',
  remove: 'Poista',
  cancel: 'Peruuta',
  participants: 'Osallistujat',
  participant: 'osallistuja',
  conferenceCall: 'Neuvottelupuhelu',
  unknownNumber: 'Nimetön',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
